import api from '../../../App/socket';

export const getBikeModel = model_id => (
    api.send({
        api: 'db',
        model: 'Bike_model',
        action: 'Read',
        options: {
            attributes: 'all',
            limit: 1,
            where: {
                _id: model_id,
            },
            include: {
                model: 'Bike_brand',
                attributes: ['name', '_id'],
            },
        },
    }).then(response => response.options).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/requests/get_bike_model_request.js